import React from 'react'
import { useTranslation } from 'react-i18next'

import Button from 'common/components/general/Button'
import Icon from 'common/components/general/Icon'

interface Props {
  title: string
  iconName: string
  actionButtonTitle: string
  onActionClick: () => void
}

const RowWithAction: React.FC<Props> = ({ title, iconName, onActionClick, actionButtonTitle }) => {
  const { t: translate } = useTranslation('ichra-decision-tool')
  return (
    <div className="flex_space_between">
      <div>
        <h5>{title}</h5>
      </div>
      <div>
        <Button type="primary" onClick={() => onActionClick()}>
          <Icon type={iconName} fontAwesome className="mr-8" />
          <span>{actionButtonTitle}</span>
        </Button>
      </div>
    </div>
  )
}

export default RowWithAction
